export const YoutubeApi = (function () {

    class YtPlayer extends EventTarget {
        constructor(container, player) {
            super()
            this.container = container
            this.videoPlayer = player || container
            this.videoID = this.videoPlayer.dataset.videoId || null
            this.player = null
            this.playerReady = false
            this.events = []
            this._init()
        }

        async _init() {
            if(window.YT === undefined) {
                await new LoadYtScript().loadScript()
                this.createEvents()
                this.callApi()
                return
            }
            this.createEvents()
            this.callApi()
        }

        createEvents() {
            this.events['loaded'] = new CustomEvent('loaded', {
                bubbles: true,
                detail: {
                    getValue: () => this.videoPlayer
                }
            })
            this.events['play'] = new CustomEvent('play', { bubbles: true })
            this.events['pause'] = new CustomEvent('pause', { bubbles: true })
            this.events['ended'] = new CustomEvent('ended', { bubbles: true })
        }

        async callApi() {
            const target = await this.createPlayer()
            this.playerReady = true
            this.dispatchEvent(this.events['loaded'])
        }

        createPlayer() {
            return new Promise((resolve, reject) => {
                this.player = new YT.Player(this.videoPlayer, {
                    height: '100%',
                    width: '100%',
                    videoId: `${this.videoID}`,
                    playerVars: {
                        'playsinline': 1,
                        // 'autoplay': 0,
                        'controls': 0,
                        'autohide': 1,
                        // 'wmode': 'opaque',
                    },
                    events: {
                        'onReady': (e) => {
                            resolve(e.target)
                            this.onPlayerReady(e)
                        },
                        'onStateChange': (e) => this.onPlayerStateChange(e)
                    },

                })
            })

        }



        // Generic methods
        onPlayerReady(e) {
            //console.log(e.target.playVideo())
        }

        onPlayerStateChange(e) {
            this.playing = (this.player.getPlayerState() === 1) ? true : false
            switch (this.player.getPlayerState()) {
                case 1:
                    this.dispatchEvent(this.events['play'])
                    break
                default:
                    this.dispatchEvent(this.events['pause'])
            }
        }

        // callbacks
        play() {
            this.player.playVideo()
        }
        pause() {
            this.player.pauseVideo()
        }
        stop() {
            this.player.stopVideo()
        }
    }

    function LoadYtScript() {
        this.scriptTag = document.querySelector('[id*="youtube-api"]')
    }

    LoadYtScript.prototype = {

        loadScript() {
            return new Promise((resolve, reject) => {
                if(!this.scriptTag) {
                    this.scriptTag = document.createElement('script')
                    this.scriptTag.setAttribute('id', `youtube-api--${Math.round(Math.random() * 10000)}`)
                    this.scriptTag.src = "https://www.youtube.com/iframe_api"
                    document.body.append(this.scriptTag)
                }

                this.scriptTag?.addEventListener('load', function() {
                    setTimeout(() => resolve(), 1000)
                })
                this.scriptTag?.addEventListener('error', reject)
            })
        }
    }

    return {
        YtPlayer,
        LoadYtScript
    }

})()

export default YoutubeApi